// extracted by mini-css-extract-plugin
module.exports = {"component":"ZoneRevealOverlay_component__eP9fL","revealed":"ZoneRevealOverlay_revealed__oFRLG"};